import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  PropertyLoginAction,
  saveUser,
  saveAgreementDetail
} from "../../store/slices/authenticationSlice";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import PropertyModal from "./PropertyModal";
import ForgotPassword from "components/forgot-password/ForgotPassword";
import OTPInput from "react-otp-input";
import Services from "API/services";
import { Dropdown } from 'react-bootstrap';

import { LuMonitor } from "react-icons/lu";
import { TbSettingsAutomation } from "react-icons/tb";
import { BsGraphUp } from "react-icons/bs";
import { BiSupport } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  authenticationSeletor,
} from "../../store/slices/authenticationSlice";

const Register = () => {

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const [viewBtn, setViewBtn] = useState(false);
  const [show, setShow] = useState(false);

  const [forgotShow, setForgotShow] = useState(false)
  const handleClose = () => setForgotShow(false);
  const { userDetail } = useSelector(authenticationSeletor);

  useEffect(() => {
      if (userDetail?.token) {
        navigate('/dashboard')
      }
    }, [userDetail])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const { Logolandingpage, LogoSymbol } = Imagesdata || {};

  const [userData, setUserData] = useState({});
  const dispatch = useDispatch();

  const [loginMethod, setLoginMethod] = useState('password')
  const [otp, setOtp] = useState("otp");
  const [showOtpBox, setShowOtpBox] = useState(false)

  const toggleLoginMethod = () => {
    // setLoginMethod(prev => (prev === 'password' ? 'otp' : 'password'));
    setLoginMethod('otp');
    setShowOtpBox(false)
    setOtp("");
  }

  const submitHandler = async (payload) => {
    if (loginMethod === "otp" && (!payload.otp || payload.otp.length !== 4 || !/^\d{4}$/.test(payload.otp))) {
      toast.error("Please enter a valid 4-digit OTP");
      return;
    }
    let data = {
      email: payload.email,
      // otp: otp
      otp: payload.otp
    }
    let userInfo = {
      email: payload.email,
      password: payload.password
    }
    const user = await dispatch(PropertyLoginAction(loginMethod == "otp" ? data : userInfo, loginMethod));
    if (user?.property?.status === 3) {
      toast.error(`Your property is currently blocked. Please contact the RROOMS support team for assistance`, {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return
    }
    if (user === "Pass") {
      toast.error(`${loginMethod == 'password' ? 'Username or Password' : 'OTP'} is incorrect*`, {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    const propertyData = user?.userProperty?.[0] || user?.ownerProperty?.[0];
    if (!propertyData) {
      toast.error("No property data found for the user.", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    dispatch(saveAgreementDetail({
      name: propertyData.name,
      address: propertyData.address,
      email: propertyData.propertyEmailId,
      propertyId: user.propertyId,
      userId: user.id,
      userName: user.firstName,
    }));
    setUserData(user);
    if (user.propertyLength > 1) {
      setShow(true);
      return;
    }
    const agreement = user?.ownerProperty?.[0]?.agreement ?? user?.userProperty?.[0]?.agreement;
    if (agreement === 0) {
      navigate(`/property-agreement-accept/${user.id}`, { state: user });
      return;
    }
    dispatch(saveUser(user, user.property, navigate));
  };

  const [otpTimer, setOtpTimer] = useState(0);
  const startOtpTimer = () => {
    setOtpTimer(60);
  };

  useEffect(() => {
    let timerInterval;
    if (otpTimer > 0) {
      timerInterval = setInterval(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timerInterval);
  }, [otpTimer]);

  const sendOtp = async (payload) => {
    const data = {
      email: payload.email
    }
    try {
      const res = await Services.auth.generateOtpForPropertyUser(data)
      if (res.data.status == true) {
        setShowOtpBox(true)
        setLoginMethod('otp')
        toast.success(res.data.message, {
          autoClose: 3000,
          pauseOnHover: true
        });
        startOtpTimer();
      }
    }
    catch (err) {
      toast.error("Email Id not found", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
    }
  }

  return (
    <section className="login-page">
      <div className="topbar">
        <div className="login-container">
          <div className="flex justify-content-between align-items-center">
            <figure>
              <a href="/" className="logo">
                <img alt="" src={LogoSymbol} /> <p>360</p>
              </a>
            </figure>
            <div className="right">
              <a href="https://rrooms.in/property-enquiry" target="_blank" className="btn btn-primary">Register Your Hotel (Free)</a>
              <span className="ml-2">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <BsThreeDotsVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Link to="/admin-login">Login to RROOMS Admin</Link>
                  </Dropdown.Menu>
                </Dropdown>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="login-panel">
        <div className="login-container">
          <div className="row">
            <div className="col-lg-6">
              <div className="col-left">
                <h1>Boost your property management with <span className="text-logo">RROOMS 360 PMS</span></h1>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><LuMonitor /></span>
                        <h6>Centralized <span>Platform</span></h6>
                      </div>
                      <p>Manage all operations from one unified interface</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><TbSettingsAutomation /></span>
                        <h6>Automated <span>Workflows</span></h6>
                      </div>
                      <p>Optimize tasks and improve operational efficiency</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><BsGraphUp /></span>
                        <h6>Revenue <span>Management</span></h6>
                      </div>
                      <p>Maximize profitability with dynamic pricing tools</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="column">
                      <div className="flex align-items-center">
                        <span className="icon"><BiSupport /></span>
                        <h6>24/7 <span>Support</span></h6>
                      </div>
                      <p>Access expert assistance anytime, day or night</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 last">
              <div className="col-right">
                <div className="form-wrap">
                  <div className="head" style={{ textTransform: "uppercase" }}>
                    Property Login
                  </div>
                  <div className="admin-login-form form-inner">
                    <h2>Login</h2>
                    <form
                      onSubmit={handleSubmit(loginMethod == "otp" ? sendOtp : submitHandler)}
                    >
                      <div className="form-group">
                        <label>Enter Registered Email</label>
                        <input
                          type="text"
                          placeholder="Email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Enter a valid email address"
                            }
                          })}
                        />
                        {errors.email && (
                          <p className="text-danger fs-8 m-0">{errors.email.message}</p>
                        )}
                      </div>

                      {
                        showOtpBox &&
                        <div className="form-group">
                          <label>Enter Mobile OTP</label>
                          <OTPInput
                            value={otp}
                            onChange={(val) => {
                              setOtp(val);
                              if (val.length === 4) {
                                setTimeout(() => {
                                  handleSubmit((formValues) => {
                                    submitHandler({ ...formValues, otp: val });
                                  })();
                                }, 100);
                              }
                            }}
                            numInputs={4}
                            shouldAutoFocus={true}
                            renderInput={(props) => (
                              <input
                                {...props}
                                type="number"
                                className="Otp-form-control"
                              />
                            )}
                          />

                          <div style={{ marginTop: "8px" }}>
                            <button
                              type="button"
                              onClick={handleSubmit(sendOtp)}
                              disabled={otpTimer > 0}
                              style={{
                                fontSize: "12px",
                                padding: "6px 14px",
                                cursor: otpTimer > 0 ? "not-allowed" : "pointer"
                              }}
                            >
                              {otpTimer > 0 ? `Resend OTP in ${otpTimer}s` : "Resend OTP"}
                            </button>
                          </div>
                        </div>
                      }
                      {
                        loginMethod == "password" &&
                        <div className="form-group">
                          <label>Enter Your Password</label>
                          <div className="icon_input">
                            <input
                              type={viewBtn ? "text" : "password"}
                              placeholder="**********"
                              {...register("password", { required: "Password is required" })}
                            />
                            <div onClick={() => setViewBtn(!viewBtn)}>
                              <FontAwesomeIcon
                                icon={`fa-solid ${viewBtn ? "fa-eye-slash" : "fa-eye"}`}
                              />
                            </div>
                          </div>
                          {(errors.password && loginMethod != "otp") && (
                            <p className="text-danger fs-8 m-0">{errors.password.message}</p>
                          )}
                        </div>
                      }

                      <div className="form-group">
                        <div className="flex justify-content-between align-items-center">
                          <button type="submit" className="btn btn-success" style={{ padding: "9px 40px" }}>Login</button>
                          {
                            loginMethod != "otp" ? (
                              <span className="text-primary" disabled={otpTimer > 0}
                                style={{
                                  fontSize: "14px",fontWeight:'500',textDecoration:"underline",color:"",
                                  cursor: otpTimer > 0 ? "not-allowed" : "pointer"
                                }} onClick={() => { setLoginMethod('otp'); handleSubmit(sendOtp)() }}>Login With OTP</span>
                            ) : ''
                          }
                        </div>
                      </div>
                      <p className="mb-0">
                        <span className="text-danger cursor-pointer fs-8" style={{
                                  fontSize: "14px",fontWeight:'500',textDecoration:"underline"                                  
                                }} onClick={() => setForgotShow(true)}>Forget Password</span>
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ForgotPassword show={forgotShow} onHide={handleClose} userType="propertyUser" />
      <PropertyModal show={show} setShow={setShow} user={userData} />
    </section>
  );
};

export default Register;
